import { Avatar } from "@mui/material";
import { useCachedImage } from "../hooks/useCacheImage"

const CachedAvatar = ({ src, alt, className, ...props }) => {
    const image = useCachedImage(src);

    return (<Avatar src={image} alt={alt} className={className} {...props} />)
}

export default CachedAvatar;
